module.exports = __webpack_public_path__ + "static/media/LoginPage@2x.1b9ba1d3.png";